import { ThunkAction } from 'redux-thunk';

import { CompanyJwt,SignUpData, AuthAction, SET_USER, User, SET_LOADING, SIGN_OUT, SignInData, SET_ERROR, NEED_VERIFICATION, SET_SUCCESS } from '../types';
import { RootState } from '..';
import Axios from 'axios'

import { getRequestParams } from '../../tools/service'
import { base_url } from '../../utils/env';

//signin

export const signIn = (data: SignInData, onError: () => void): ThunkAction<void, RootState, null, AuthAction> => {
    return  dispatch => {
        let axiosResponse = "" as any;
       
            let url = `${base_url}api/login`;
            
            let formData = `{"userName":"${data.username}","password":"${data.password}","masterId":"${data.masterId}","agentName":"${data.agentName}"}`;
            
            axiosResponse = Axios.post(url, formData, {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then( response => {
                if (response.data['jwt']) {
                    localStorage.setItem("token", response.data['jwt'])
                    const token = getRequestParams() as any
                    localStorage.setItem("jwt_exp", (+ token["exp"] * 1000).toString());
                    localStorage.setItem("company_jwt", JSON.stringify( token["companies"] ) )
                    const companies = JSON.parse(localStorage.getItem("company_jwt")  || '[]');
                    localStorage.setItem("currentCompanySelected",companies[0].companyId as string)
                    const userData: User = {
                        username: data.username,
                        iss: token["iss"],
                        sub: token["sub"],
                        swapiUrl: token["swapiUrl"],
                        connectionId: token["connectionId"]               
                    };
                    dispatch({
                        type: SET_USER,
                        payload: userData
                    });
                }
            })
            .catch((err) => {
                console.log(err)
                console.info(err.response.data.message)
                onError();
                dispatch(setError(err.response.data.message));
            })
    }
}


// Set error
export const setError = (msg: string): ThunkAction<void, RootState, null, AuthAction> => {
    return dispatch => {
        dispatch({
            type: SET_ERROR,
            payload: msg
        });
    }
}



// Set loading
export const setLoading = (value: boolean): ThunkAction<void, RootState, null, AuthAction> => {
    return dispatch => {
        dispatch({
            type: SET_LOADING,
            payload: value
        });
    }
}

// Set need verification
export const setNeedVerification = (): ThunkAction<void, RootState, null, AuthAction> => {
    return dispatch => {
        dispatch({
            type: NEED_VERIFICATION
        });
    }
}

// Set success
export const setSuccess = (msg: string): ThunkAction<void, RootState, null, AuthAction> => {
    return dispatch => {
        dispatch({
            type: SET_SUCCESS,
            payload: msg
        });
    }
}